module.exports = __webpack_public_path__ + "img/loading.ce1a3855.png";